
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../../controlador';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Cargando: boolean = false;
        public Abrir: boolean = false;
        public get Ok(): boolean
        {
            return this.Pedido && !this.Pedido.Tipo.esMercadoLibre && !this.Pedido.Tags.Facturado;
        }

        public async Ejecutar()
        {

            this.Controlador.Vista.BarraDerecha.Modo = 'agregar_pago';
            return;

            if ( this.Pedido.Pagos.hasRows() )
            {
                return await Utiles.Mensajes.Aceptar( 'Error', 'El pedido no debe tener pagos asociados' )
            }
            
            //if ( !this.Pedido.Envio.Tipo.esRetiraCliente )
            //{
            //    return await Utiles.Mensajes.Aceptar( 'Error', 'El pedido debe ser retira cliente' )
            //}

            if ( await Utiles.Mensajes.SiNo( '¿Habilitar pago presencial?', 'Antes de entregar la mercadería controle el pago correspondiente' ) )
            {
                this.Cargando = true;
                let e = await this.Pedido.HabilitarPagoEnSucursal();
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Habilitado!' );
                    await Wait( 500 );
                    window.location.reload();
                } else
                {
                    Utiles.Notificaciones.Error( 'Ordén no encontrada' );
                }
                this.Cargando = false;
            }
        }
    }
